module.exports = __webpack_public_path__ + "img/left-from-line.93a8bad1.svg";